import { render, staticRenderFns } from "./editorV2mini.vue?vue&type=template&id=388d2f70"
import script from "./editorV2mini.vue?vue&type=script&lang=js"
export * from "./editorV2mini.vue?vue&type=script&lang=js"
import style0 from "./editorV2mini.vue?vue&type=style&index=0&id=388d2f70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports